import { ButtonProps } from "@chakra-ui/react";
import React from "react";
import APButton from "./APButton";

const APIconButton = ({
                        children,
                        variant = "icon",
                        colorScheme = "primary",
                        ...others
                      }: ButtonProps) => {
  return (
    <APButton
      variant={variant}
      colorScheme={colorScheme}
      paddingInline={0}
      marginInline={0}
      fontSize={"2xl"}
      {...others}
    >
      {children}
    </APButton>
  );
};

export default APIconButton;
